import React from 'react';
import { ServerErrorPage } from '@/pages/errors/ServerErrorPage';

/**
 * 런타임 에러 캐치 — render/effect 단계에서 throw 된 예외를 잡아 500 페이지로 폴백.
 *
 * React 19 + react-router-dom v7 환경에서는 라우트 errorElement 도 사용 가능하지만,
 * 기존 Routes 트리 전체를 감싸는 클래스형 ErrorBoundary 가 가장 광범위한 보호를 제공.
 */
interface State {
  hasError: boolean;
  error: unknown;
}

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: unknown): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: unknown, info: unknown) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <ServerErrorPage error={this.state.error} />;
    }
    return this.props.children;
  }
}
